import { render, staticRenderFns } from "./Soundbutton.vue?vue&type=template&id=855771ba&scoped=true&"
import script from "./Soundbutton.vue?vue&type=script&lang=js&"
export * from "./Soundbutton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855771ba",
  null
  
)

export default component.exports